import React from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { ImportExport } from './components';
const ImportExport = React.lazy(() => import(/* webpackChunkName: "ImportExport" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/import-export" component={ImportExport} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/ImportExport/routes.js